export default __webpack_public_path__ + "static/economic-justice-workers-rights-hero-466937e1d5e2b905f144c024c67f7c67.webp";